import React, { Children, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Tab from './Tab';
import TabContent from './TabContent';

import './tabCarousel.scss';

export function TabCarousel({
	tabs = [],
	tabContent = [],
	className,
	initialSelectedTab = 0,
}) {
	const [selectedTab, setSelectedTab] = useState(initialSelectedTab);

	const selectTab = (selectedTabIndex) => {
		setSelectedTab(selectedTabIndex);
	};
	return (
		<div className={classnames(className, 'tab-carousel')}>
			<div className={classnames('tab-carousel-tabs')}>
				{Children.toArray(
					tabs.map((tab, i) => (
						<Tab
							onClick={() => selectTab(i)}
							selected={selectedTab === i}
						>
							{tab}
						</Tab>
					)),
				)}
			</div>
			<div className={classnames('tab-carousel-content-blocks')}>
				{Children.toArray(
					tabContent.map((content, i) => (
						<TabContent selected={selectedTab === i}>
							{content}
						</TabContent>
					)),
				)}
			</div>
		</div>
	);
}

TabCarousel.propTypes = {
	className: PropTypes.string,
	tabs: PropTypes.arrayOf(PropTypes.node),
	tabContent: PropTypes.arrayOf(PropTypes.node),
	initialSelectedTab: PropTypes.number,
};

export default TabCarousel;
